import { DynamicFormV2Palette } from "@mui/material";

export type FormTextFieldComponentTokenType = {
  backgroundColor: string;
  textColor: string;
  placeholderTextColor: string;
  borderColor: string;
  hoverBorderColor: string;
  errorBorderColor: string;
};

export const assignTextFieldComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    backgroundColor: isLightMode ? formsPalette.surface.reverse : formsPalette.surface.supershy,
    textColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
    placeholderTextColor: formsPalette.text.supershy,
    borderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.intense,
    hoverBorderColor: formsPalette.border.brand,
    errorBorderColor: formsPalette.border.error,
  } as FormTextFieldComponentTokenType;
};
